import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Qué pasa después de SAINT®?",
    answer:
      "Tras la semana de SAINT®, el equipo clínico realiza un seguimiento. No todo el mundo alcanza la remisión; los resultados individuales pueden variar. Se analizan las opciones de seguimiento en la consulta.",
  },
];

export const esWhatHappensAfter = makeEsArticle({
  slug: "what-happens-after-saint-tms",
  title: "¿Qué pasa después de SAINT® TMS?",
  description:
    "Tras la semana de SAINT®, el equipo clínico realiza un seguimiento. No todo el mundo alcanza la remisión; los resultados individuales pueden variar.",
  h1: "¿Qué pasa después de SAINT®?",
  breadcrumbLabel: "Después de SAINT®",
  shortAnswer:
    "Tras los cinco días de SAINT®, el equipo clínico realiza un seguimiento para evaluar la respuesta. No todo el mundo alcanza la remisión; los resultados individuales pueden variar y no están garantizados. El equipo habla sobre expectativas realistas y opciones de seguimiento durante la consulta. SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos.",
  keyTakeaways: [
    "El equipo clínico realiza un seguimiento tras SAINT®.",
    "No todo el mundo alcanza la remisión.",
    "Los resultados individuales pueden variar y no están garantizados.",
    "Se analizan las opciones de seguimiento en la consulta.",
    "SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos.",
  ],
  sections: [
    {
      heading: "Seguimiento",
      paragraphs: [
        "Tras completar la semana de SAINT®, el equipo clínico evalúa la respuesta al tratamiento y planifica el seguimiento. Como con cualquier tratamiento para la depresión, los resultados varían de una persona a otra.",
        "No hay garantías de resultados. El equipo habla sobre expectativas realistas durante la consulta y repasa las opciones de seguimiento si fueran necesarias.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
